import { AxiosRequestConfig, AxiosResponse } from 'axios'
import HttpClient from '../http-client'
import { httpConfig } from '../constants'
import { DetailedGapDescription } from '../model/models'

export class GapDescriptionAPI extends HttpClient {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig)
    this.gapDetailedDescription = this.gapDetailedDescription.bind(this)
  }

  public gapDetailedDescription(
    id: number,
    empiricalConceptId: number,
  ): Promise<DetailedGapDescription> {
    const endpoint = `/gaps/${id}/empirical-concepts/${empiricalConceptId}/description`
    return this.get<DetailedGapDescription>(endpoint)
      .then((response: AxiosResponse<DetailedGapDescription>) => response.data)
      .catch((error) => {
        throw error
      })
  }
}

export const gapDescriptionAPI = new GapDescriptionAPI(httpConfig)
